import React from 'react';
import dayjs from 'mixins/dayjsConfig.js';
import { TaxpayerDataUncommon } from '../types';
import {getLangValue} from "mixins/helpers";

const UncommonCategory = (props: {
  taxpayerData?: TaxpayerDataUncommon;
  title: any;
  props: any;
}) => {
  const { categoryDataReportDate, categoryActCreateDate, categoryActNumber } = props.props.config;

  return (
    <>
      <tr>
        <td colSpan={2} align="center">
          <strong>
            {props.title[getLangValue(props.props.language)]}
          </strong>
        </td>
      </tr>
      <tr>
        <td>{categoryDataReportDate}</td>
        <td>
          {props.taxpayerData?.dataReportDate &&
              dayjs(props.taxpayerData?.dataReportDate).format('DD.MM.YYYY')}
        </td>
      </tr>
      <tr>
        <td>{props.title.actCreateDate || categoryActCreateDate}</td>
        <td>
          {props.taxpayerData?.actCreateDate &&
              dayjs(props.taxpayerData?.actCreateDate).format('DD.MM.YYYY')}
        </td>
      </tr>
      <tr>
        <td>{props.title.actNumber || categoryActNumber}</td>
        <td>{props.taxpayerData?.actNumber}</td>
      </tr>
    </>
  );
};

export default UncommonCategory;
